/* eslint-disable react/jsx-props-no-spreading,import/prefer-default-export */
import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';

export const Button = forwardRef(({ children, ...props }, ref) => {
  const { className, variant } = props;

  const variantMap = useMemo(
    () => ({
      primary: 'btn btn-primary py-3',
      primarySimple: 'btn border-disabled py-3',
      secondary: 'btn btn-secondary border py-3',
      outlinePrimary: 'btn btn-outline-primary py-3',
      simple: 'btn text-btn-item py-3',
      toggleItem: 'btn toggle-item toggle-item-modal',
    }),
    []
  );

  return (
    <button type="button" ref={ref} {...props} className={`${variantMap[variant]} ${className}`}>
      {children}
    </button>
  );
});

Button.displayName = 'Button';

Button.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'outlinePrimary',
    'simple',
    'primarySimple',
    'toggleItem',
  ]),
};

Button.defaultProps = {
  className: '',
  type: 'button',
  variant: 'primary',
};
